<template>
    <div class="app-float-btn" @click="openAbnormalWarnDialog">
        <img :src="!dialogVisible ? floatBtnFoldImg : floatBtnUnFoldImg">
        <span class="num">{{ statNum }}</span>
    </div>
    <el-dialog title="异常提醒" :width="600" :destroy-on-close="true" :close-on-click-modal="false"
        :before-close="handleClose" v-model="dialogVisible">
        <div class="table">
            <el-table :data="dataList" border style=" margin-bottom: 16px;width: 100%">
                <el-table-column type="index" label="序号" width="60" />
                <el-table-column prop="tips" label="异常类型" />
                <el-table-column prop="num" width="100" label="数量" />
                <el-table-column prop="actions" width="140" label="操作">
                    <template #default="scope">
                        <el-button type="primary" @click="handlePageJump(scope.row.tipsType)">去处理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <template #footer>
            <div class="flex-container flex-jcc">
                <el-button class="btn" @click="handleClose">关闭</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { defineComponent, reactive, toRefs, onMounted } from 'vue';
import { queryWaybillWarningUnion } from '@/api/waybill/waybillCenter.js';
import { useRouter, useRoute } from 'vue-router';
import emitter from '@/utils/eventBus';
import { NtpAbnomalWarningExceptionTypeDict } from '@/views/transport/entity/dict'
import { createRouteQuery } from '@/utils/searcher'

export default defineComponent({
    name: 'AbnormalWarning',
    // eslint-disable-next-line max-lines-per-function
    setup() {
        const state = reactive({
            dialogVisible: false,
            floatBtnFoldImg: require('../../assets/images/float_btn_fold.png'),
            floatBtnUnFoldImg: require('../../assets/images/float_btn_unfold.png'),
            haveShownListModal: false,
            statNum: -1,
            dataList: []
        });
        const router = useRouter();
        const route = useRoute();

        const getWaybillWarningUnion = (isInit = true) => {
            return queryWaybillWarningUnion({}).then(res => {
                if (res && +res.code === 0) {
                    state.dataList = [];
                    state.statNum = 0;
                    const list = res.data;
                    // 弹框中只展示特定的几种类型 https://cf.annto.com/pages/viewpage.action?pageId=20121360
                    // tipsType 字典为 NtpAbnomalWarningExceptionTypeDict - NTP_WAYBILL_WARN_TYPE
                    // eslint-disable-next-line no-magic-numbers
                    const dataList = list.filter(x => [3, 4, 5, 6, 8, 9, 11, 12, 13, 14].includes(+x.tipsType)).map(x => {
                        state.statNum = state.statNum + (+x.num);
                        return x;
                    });
                    if (!isInit) state.dataList = dataList;
                    // eslint-disable-next-line no-magic-numbers
                    if (state.statNum > 99) {
                        state.statNum = '99+';
                    }
                    // 过滤掉【司机审核驳回】和【车辆审核驳回】
                    emitter.emit('abnormalWarningList', list.filter(x => ![11, 12].includes(+x.tipsType)));
                }
            });
        };

        const checkOpenModal = async (route, statNum) => {
            if (typeof statNum !== 'number' || statNum < 0) {
                await getWaybillWarningUnion();
                statNum = Number(state.statNum)
            }

            if (!state.haveShownListModal && ['/mod/ntp/index'].includes(route.path)) {
                state.haveShownListModal = true
                await getWaybillWarningUnion();
                if (Number(state.statNum) > 0) {
                    openAbnormalWarnDialog()
                }
            }
        }

        router.afterEach(async (to) => {
            checkOpenModal(route, Number(state.statNum))
        })

        onMounted(async () => {
            await getWaybillWarningUnion();
            checkOpenModal(route, Number(state.statNum))
        });

        const openAbnormalWarnDialog = () => {
            state.dialogVisible = true;
            getWaybillWarningUnion(false);
        };

        const handlePageJump = tipsType => {
            state.dialogVisible = false;

            const nTipsType = Number(tipsType)

            const fromComponent = 'COMPONENT:ABNORMAL_WARNING'

            if (nTipsType === NtpAbnomalWarningExceptionTypeDict.DRIVER_AUDIT_REJECTION) {
                // 点击去处理进入【熟车管理】页面并按查询 【创建时间】最近三个月，【司机审批状态】为【驳回】
                return router.push({
                    name: 'familiarCarManage',
                    query: createRouteQuery(fromComponent)
                        .param('driverMipStatuss', '30') // 30: 驳回
                        .timeRange('__createTime__', 3, 'month')
                        .done()
                });
            }

            if (nTipsType === NtpAbnomalWarningExceptionTypeDict.CAR_AUDIT_REJECTION) {
                // 点击去处理进入【熟车管理】页面并按查询 【创建时间】最近三个月，【车辆审批状态】为【驳回】
                return router.push({
                    name: 'familiarCarManage',
                    query: createRouteQuery(fromComponent)
                        .param('carMipStatuss', '30') // 30: 驳回
                        .timeRange('__createTime__', 3, 'month')
                        .done()
                });
            }

            if (nTipsType === NtpAbnomalWarningExceptionTypeDict.BILL_AUDIT_ERROR) {
                // 点击去处理进入【异常运单】页面并按查询 【调度时间】最近三个月
                return router.push({
                    name: 'abnormalWaybillCenter',
                    query: createRouteQuery(fromComponent)
                        .param('searchTimeType', '10') // 调度时间
                        .timeRange('searchTime', 7, 'day') // // 时间范围
                        .done()
                });
            }

            if (nTipsType === NtpAbnomalWarningExceptionTypeDict.BILL_AUDIT_REFUSE) {
                // 点击去处理进入【运单列表】页面并按查询 【调度时间】最近三个月，【预审状态】为【未通过】
                return router.push({
                    name: 'waybillCenter',
                    query: createRouteQuery(fromComponent)
                        .param('searchTimeType', '10') // 调度时间
                        .timeRange('searchTime', 7, 'day') // // 时间范围
                        .param('preStatus', '2') // 2: 未通过
                        .done()
                });
            }

            if (route.name === 'transitTracking') {
                emitter.emit('reloadWaybillWarningData', tipsType);
            } else {
                router.push({
                    name: 'transitTracking',
                    query: {
                        tipsType
                    }
                });
            }
        };

        const handleClose = () => {
            state.dataList = [];
            state.dialogVisible = false;
        };

        return {
            ...toRefs(state),
            openAbnormalWarnDialog,
            handlePageJump,
            handleClose
        };
    }
});
</script>

<style lang="less" scoped>
.app-float-btn {
    position: fixed;
    right: -50px;
    bottom: 30%;
    z-index: 99;

    img {
        cursor: pointer
    }

    .num {
        position: absolute;
        top: 6px;
        right: 50px;
        padding: 4px 10px;
        font-size: 13px;
        text-align: center;
        color: #fff;
        background-color: #f56c6c;
        border-radius: 10px;
    }
}
</style>
